import config from "./config";
import Axios from "axios";
import Cookies from "universal-cookie";
import { deploymentTypes, serverType } from "../deployment-config";
const axiosRetry = require("axios-retry");

Axios.defaults.withCredentials = true;

const createAxiosInstance = () => {
  const cookies = new Cookies();
  const instance = Axios.create(config);

  instance.interceptors.request.use((config) => {
    const tokenInfo = JSON.parse(localStorage.getItem("AUTH-TOKEN") || "{}");
    const tokenExpiration = tokenInfo.expiration;
    const currentTime = Date.now();

    if (tokenExpiration && currentTime - tokenExpiration > 86400000) {
      localStorage.clear();
      window.location.reload();
      return Promise.reject("Token expired");
    }

    if (localStorage.getItem("user")) {
      config.headers["ck"] = cookies.get("infoin");
      config.headers["jwt"] = tokenInfo.token;
      config.headers["user"] = JSON.stringify({
        email: localStorage.getItem("email_for_forgot_password"),
        userId: localStorage.getItem("apex_userid"),
      });
    } else {
      config.body = {
        email: localStorage.getItem("email_for_forgot_password"),
        userId: localStorage.getItem("apex_userid"),
      };
    }

    return config;
  }, ic1_err);

  instance.interceptors.request.use(encrypter_ic, ic1_err);
  instance.interceptors.response.use(decrypter_ic, ic1_err);

  return instance;
};

const encrypter = (url, body = {}) => {
  let path = url.split("api/v1/")[1];
  url = url.split("api/v1")[0] + "api/v1/" + btoa(path);
  return { url, body };
};

const encrypter_ic = (config) => {
  if (serverType !== deploymentTypes.development && serverType !== deploymentTypes.localDevelopment) {
    config.url = encrypter(config.url).url;
  }
  return config;
};

const decrypter_ic = (response) => {
  if (response.data) {
    if (serverType !== deploymentTypes.development && serverType !== deploymentTypes.localDevelopment) {
      response.data = JSON.parse(atob(response.data));
    }
  }
  if (response.data && response.data.token) {
    localStorage.setItem("AUTH-TOKEN", JSON.stringify(response.data));
  }
  return response;
};

const ic1_err = (error) => {
  return Promise.reject(error);
};

const axiosInstance = createAxiosInstance();

axiosRetry(axiosInstance, {
  retries: 3,
  retryDelay: (retryCount) => {
    console.warn(`retry attempt: ${retryCount}`);
    return retryCount * 2000;
  },
  retryCondition: (error) => {
    return error.response && error.response.status === 404;
  },
});

export default axiosInstance;